module.exports = __webpack_public_path__ + "img/charging-station.4141969b.png";